import { Link } from "react-router-dom";

interface EpisodeCardProps {
  id: string;
  number: number;
  title: string;
  summary: string;
  airDate: string;
  cover: string;
  season?: number;
}

export default function EpisodeCard({
  id,
  number,
  title,
  summary,
  airDate,
  cover,
}: EpisodeCardProps) {
  return (
    <Link
      to={`/episode/${id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden bg-secondary-200">
        <img
          src={cover}
          alt={`《年轻的母亲2》第${number}集 ${title} 剧照`}
          title={`第${number}集 ${title} - 年轻的母亲2 剧照`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-primary-950/80 px-2 py-1 font-label text-xs font-semibold text-background-50">
          <i className="ri-play-list-2-line text-sm"></i>
          第 {number} 集
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {title}
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-2">
          {summary}
        </p>
        <div className="mt-3 flex items-center gap-2 border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-calendar-line text-sm"></i>
          </span>
          <span>首播 {airDate}</span>
        </div>
      </div>
    </Link>
  );
}